export default function Coupon2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path
                d="M9 13.6207L26.188 6.63453C27.0474 6.28523 28.0266 6.70484 28.3664 7.56802L30.7491 13.6207"
                stroke="#F7A40A"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15 20H19.5017M15 24.5721H25.5017" stroke="#F7A40A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 15.2541C5 14.3336 5.74619 13.5874 6.66667 13.5874H33.3333C34.2538 13.5874 35 14.3336 35 15.2541V18.1595C32.7509 18.1595 30.5 19.6829 30.5 22.3499C30.5 25.0168 32.7509 27.3037 35 27.3037V30.2091C35 31.1296 34.2538 31.8758 33.3333 31.8758H6.66667C5.74619 31.8758 5 31.1296 5 30.2091V27.3037C7.25086 27.3037 9.5 25.7802 9.5 22.7316C9.5 19.6829 7.24914 18.1595 5 18.1595V15.2541Z"
                stroke="#010101"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
